import { styled, disabledProps, css } from "../../../styled-components";

export const Spinner = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.7778 10C17.7778 5.70445 14.2955 2.22222 10 2.22222V0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10H2.22222C2.22222 14.2955 5.70445 17.7778 10 17.7778C14.2955 17.7778 17.7778 14.2955 17.7778 10Z"
            fill="currentColor"
        />
    </svg>
);

export const SwitchViewStyle = styled.div<{ isEnabled: boolean }>`
    padding: ${p => p.theme.componentSmallInnerVerticalPadding}px ${p => p.theme.pageMarginMedium}px;

    ${p => !p.isEnabled && disabledProps}

    display: flex;
    align-items: center;
`;

export const TextArea = styled.label`
    display: flex;
    flex-direction: column;

    min-width: 1px;
    flex-grow: 1;
`;

export const BigSwitchWrapper = styled.button`
    position: relative;
    margin-left: 8px;

    flex-shrink: 0;
`;

export const Title = styled.div`
    ${p => p.theme.listItem.titleFontStyle};

    color: ${p => p.theme.fgColorDark};

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;

export const Description = styled.div`
    ${p => p.theme.listItem.detailFontStyle};
    color: ${p => p.theme.fgColorMedium};
    margin-top: 4px;

    .no-wrap & {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
`;

export const BigTrack = styled.div<{ checked: boolean }>`
    width: 51px;
    height: 32px;
    background: ${p => (p.checked ? p.theme.switch.big.selectedBackgroundColor : p.theme.switch.big.backgroundColor)};
    border-radius: 18px;
    box-sizing: border-box;
    transition: border 0.2s, background-color 0.2s;
`;

const ThumbChildProps = css`
    position: absolute;
    left: 4px;
    top: 4px;
    width: calc(100% - 8px);
    height: calc(100% - 8px);

    color: ${p => p.theme.primaryAccentColor};

    @keyframes switch-spinner-forever {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }

    animation: switch-spinner-forever 1s linear infinite;
`;

export const BigThumb = styled.div<{ checked: boolean }>`
    position: absolute;
    left: 2px;
    top: 2px;
    width: 28px;
    height: 28px;

    border-radius: 50%;

    background: ${p => p.theme.switch.big.thumbColor};
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.16);
    box-sizing: border-box;

    ${p => p.checked && "transform: translateX(19px);"}

    transition: transform 0.2s;

    > * {
        ${ThumbChildProps}
    }
`;

export const CompactSwitchWrapper = styled.button`
    position: relative;
    margin-left: 8px;

    flex-shrink: 0;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 42px;
    height: 21px;
`;

export const CompactTrack = styled.div<{ checked: boolean }>`
    width: 28px;
    height: 15px;
    background: ${p => (p.checked ? p.theme.primaryAccentColor : p.theme.switch.compact.backgroundColor)};
    opacity: 0.4;
    border-radius: 7.5px;

    transition: background-color 0.2s;
`;

export const CompactThumb = styled.div<{ checked: boolean }>`
    position: absolute;
    left: 0;
    top: 0;
    width: 21px;
    height: 21px;

    border-radius: 50%;

    background: ${p => (p.checked ? p.theme.primaryAccentColor : p.theme.switch.compact.thumbColor)};
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.32);

    ${p => p.checked && "transform: translateX(21px);"}

    transition: background-color 0.2s, transform 0.2s;

    > * {
        ${ThumbChildProps}
    }
`;

export const FavoriteWrapper = styled.button`
    width: 36px;
    height: 36px;

    display: flex;
    justify-content: center;
    align-items: center;
`;

export const FavoriteEmpty = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20.84 4.60999C20.3292 4.099 19.7228 3.69364 19.0554 3.41708C18.3879 3.14052 17.6725 2.99817 16.95 2.99817C16.2275 2.99817 15.5121 3.14052 14.8446 3.41708C14.1772 3.69364 13.5708 4.099 13.06 4.60999L12 5.66999L10.94 4.60999C9.9083 3.5783 8.50903 2.9987 7.05 2.9987C5.59096 2.9987 4.19169 3.5783 3.16 4.60999C2.1283 5.64169 1.54871 7.04096 1.54871 8.49999C1.54871 9.95903 2.1283 11.3583 3.16 12.39L4.22 13.45L12 21.23L19.78 13.45L20.84 12.39C21.351 11.8792 21.7563 11.2728 22.0329 10.6053C22.3095 9.93789 22.4518 9.22248 22.4518 8.49999C22.4518 7.77751 22.3095 7.0621 22.0329 6.39464C21.7563 5.72718 21.351 5.12075 20.84 4.60999V4.60999Z"
            stroke="#E9453A"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const FavoriteFull = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20.8401 4.60999C20.3294 4.099 19.7229 3.69364 19.0555 3.41708C18.388 3.14052 17.6726 2.99817 16.9501 2.99817C16.2276 2.99817 15.5122 3.14052 14.8448 3.41708C14.1773 3.69364 13.5709 4.099 13.0601 4.60999L12.0001 5.66999L10.9401 4.60999C9.90843 3.5783 8.50915 2.9987 7.05012 2.9987C5.59109 2.9987 4.19181 3.5783 3.16012 4.60999C2.12843 5.64169 1.54883 7.04096 1.54883 8.49999C1.54883 9.95903 2.12843 11.3583 3.16012 12.39L4.22012 13.45L12.0001 21.23L19.7801 13.45L20.8401 12.39C21.3511 11.8792 21.7565 11.2728 22.033 10.6053C22.3096 9.93789 22.4519 9.22248 22.4519 8.49999C22.4519 7.77751 22.3096 7.0621 22.033 6.39464C21.7565 5.72718 21.3511 5.12075 20.8401 4.60999Z"
            fill="#E9453A"
            stroke="#E9453A"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
